import { HeaderComponent } from './header/header.component';

export const UI_COMPONENTS = [HeaderComponent];

export * from './header/header.component';
